export default "__VITE_ASSET__BbhscLwh__"